import openSocket from 'socket.io-client';

import { hlog } from '../common/util';
import { NOTIFICATION_SERVER_URL, NOTIFICATION_CREATE } from '../network/api';
import { HHAxiosRequest } from '../network';
import store from '../../store';

const socket = openSocket(NOTIFICATION_SERVER_URL);

// When user is in an event, they will join a room called u1234, where 1234 is user id
// Todo: join event, toId === e1111, 1111 is event id
// Rule for toId (as known as room Id)
// U for user
// E For event
// T for team
// ex:
// U123, E111, T234

export const joinRoom = (toId) => {
  socket.emit('joinRoom', toId);
};

export const leaveRoom = (toId) => {
  socket.emit('leaveRoom', toId);
};

export const receiveMessage = (callback) => {
  socket.off('new_msg');
  socket.on('new_msg', callback);
};

export const emailVerificationEmail = (callback) => {
  socket.off('emailVerificationSuccess');
  socket.on('emailVerificationSuccess', callback);
};

export const generateMessage = async ({ userId, content, eventSlug }) => {
  try {
    await HHAxiosRequest(NOTIFICATION_CREATE, {
      userId, content, eventSlug, token: store.user.token
    });
  } catch (err) {
    hlog(err);
  }
};



// WEBPACK FOOTER //
// ./src/components/notifications/socket.js